import React from 'react';
import styled from 'styled-components';
import DoneImg from "../../assets/Done.svg";
import Description from "../../assets/Description.svg";
import EventNote from "../../assets/EventNote.svg";
import {Link, withRouter} from "react-router-dom";
import Button from "../../ui/components/buttons/button";
import {_gaPushEvent} from "../../utils/utility"

import {mdDownN, xsDown} from "../../ui/common";

const BannerStyle = styled.div`
    position: absolute;
    top: 113px;
    left: 154px;
    height: 740px;
    width: 444px;
    ${mdDownN`
        display: flex;
        flex-direction: column;
        position: relative;
        top:auto;
        left: auto;
        padding: 80px 20px 46px 20px;
        max-width: 100vw;
        width: calc(100vw);
        height: auto;
        background: linear-gradient(64.95deg, #3023AE -20%, #53A0FD 59.27%, #B4EC51 150%);
    `}
`;

const BannerTitleStyle = styled.div`
    margin-top: 18px;
    width: 361px;
    margin: 0;
    font-family: "Stag", Helvetica, Arial, serif;
    font-size: 56.0px;
    color: #fff;
    text-align: left;
    letter-spacing: 1.4px;
    line-height: 62.0px; 
    ${mdDownN`
        height: auto;
        width: auto;
        color: #FFFFFF;
        font-family: "Stag", Helvetica, Arial, serif;
        font-size: 40px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 48px;
    `}
`;

const BannerContentStyle = styled.div`
    height: 34px;
    width: 444px;
    margin: 18px 0 0 0;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 24.0px;
    color: #fff;
    text-align: left;
    line-height: 34.0px; 
    ${mdDownN`
        height: 56px;
        width: auto;
        font-size: 20px;
        font-family: "Inter", Helvetica, Arial, serif;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 28px;
        word-wrap: break-word;
        margin-top:16px;
    `}
`;

const BannerSelectionTitleStyle = styled.div`
    margin-top: 30px;
    height: 21px;
    width: 147px;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 16.0px;
    color: rgba(254, 255, 254, 1.0);
    text-align: left;
    line-height: 21.0px; 
    ${mdDownN`
        font-family: "Inter-Regular", Helvetica, Arial, serif ;
        font-weight: normal;
        letter-spacing: 0;
        line-height: 21px;
    `}
`;

const BannerSelectionGroupStyle = styled.div`
    margin-top: 19px;
    height: 106px;
    width: 288px;
    ${mdDownN`
        margin-top:21px;
    `}
`;

const BannerSelectionStyle = styled.div`
    display: flex;
    height: auto;
    width: 355px;
    margin: 0 0 15px 0;
    font-family: "Inter-Bold", Helvetica, Arial, serif;
    font-size: 17.0px;
    color: rgba(254, 255, 254, 1.0);
    text-align: left;
    line-height: 21.0px;  
    ${mdDownN`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;600&display=swap');
        font-family: "Inter-Bold", Helvetica, Arial, serif ;
        font-weight: normal;

        font-size: 16px;
        letter-spacing: 0;
        line-height: 17px;
        align-items: center;

    `}
    ${xsDown`
        font-size: 14px;
    `}
`;

const DoneImgStyle = styled.img`
    margin-right: 5px;
`;

const BtnStyle = styled.div`
    padding-top: 20px;
    height: auto;
    width: auto;
    margin: 0;
    ${mdDownN`
        padding-top: 16px;
        height: auto;
        button{
            height: 52px;
            width: auto;
            border-radius: 28px;
            font-family: "Inter-Medium", Helvetica, Arial, serif ;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 20px;
            text-align: center;
            padding: 0 27px;
            


        }
    `}
`;

const BannerDescriptionStyle = styled.div`
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    padding-left: 5px;
    ${mdDownN`
        font-family: "Inter-Regular", Helvetica, Arial, serif;
        font-weight: normal;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 17px;
    `}
    ${xsDown`
        font-size: 14px;
    `}
`;

const BannerChecklistTitleStyle = styled.div`
    margin-top: 30px;
    height: 21px;
    width: 256px;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 16.0px;
    color: rgba(254, 255, 254, 1.0);
    text-align: left;
    line-height: 21.0px; 
    ${mdDownN`
        font-family: "Inter-Regular", Helvetica, Arial, serif ;
        font-weight: normal;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 21px;
    `}
`;

const BannerChecklistGroupStyle = styled.div`
    margin-top: 19px;
    height: 71px;
    width: 288px;
    ${mdDownN`
        height: auto;
        letter-spacing: 0;
    `}
`;

const BannerChecklistStyle = styled.div`
    display: flex;
    height: auto;
    width: 455px;
    margin: 0 0 15px 0;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 17.0px;
    color: rgba(254, 255, 254, 1.0);
    text-align: left;
    line-height: 21.0px;  
    ${mdDownN`
        font-size: 16.0px;
        font-family: "Inter-Regular", Helvetica, Arial, serif;
        font-weight: normal;
        line-height: 19px;
        width: calc(100vw - 60px);
        overflow-wrap: break-word;
    `} 
    ${xsDown`
        font-size: 14px;
    `}
`;

const ChecklistImgStyle = styled.img`
    margin-right: 10px;
    ${mdDownN`
        height: 20.0px;
    `}
`;

const  BannerSelectionWarningBubbleStyle = styled.div`
    padding-top: 25px;
    height: 21px;
    width: auto;
    font-family: "Inter-Regular", Helvetica, Arial, serif;
    font-size: 16.0px;
    color: rgba(254, 255, 254, 1.0);
    text-align: left;
    line-height: 21.0px; 
    ${mdDownN`
        font-family: "Inter-Regular", Helvetica, Arial, serif ;
        font-weight: normal;
        letter-spacing: 0;
        line-height: 21px;
    `}
`;

const LandingBanner = (props) => {
    return (
        <BannerStyle>
                <BannerTitleStyle>
                    SME Business Insurance
                </BannerTitleStyle>
                <BannerContentStyle>
                    We help you operate with confidence.
                </BannerContentStyle>
                <BannerSelectionTitleStyle>
                    We will insure your:
                </BannerSelectionTitleStyle>
                <BannerSelectionGroupStyle>
                    <BannerSelectionStyle>
                        <DoneImgStyle src={DoneImg} />
                        <div>Office </div>
                        <BannerDescriptionStyle>(As low as S$260.02)</BannerDescriptionStyle>
                    </BannerSelectionStyle>
                    <BannerSelectionStyle>
                        <DoneImgStyle src={DoneImg} />
                        <div>Retail Shop</div>
                        <BannerDescriptionStyle>(As low as S$278.12)</BannerDescriptionStyle>
                    </BannerSelectionStyle>
                    <BannerSelectionStyle>
                        <DoneImgStyle src={DoneImg} />
                        <div>Groceries Store</div>
                        <BannerDescriptionStyle>(As low as S$284.96)</BannerDescriptionStyle>
                    </BannerSelectionStyle>
                </BannerSelectionGroupStyle>
                <BannerChecklistTitleStyle>
                    Info to prepare:
                </BannerChecklistTitleStyle>
                <BannerChecklistGroupStyle>
                    <BannerChecklistStyle>
                        <ChecklistImgStyle src={Description} />
                        <div>UEN ( you would need UEN to insure your policy)</div>
                    </BannerChecklistStyle>
                    <BannerChecklistStyle>
                        <ChecklistImgStyle src={EventNote} />
                        <div>Asset Values</div>
                    </BannerChecklistStyle>
                </BannerChecklistGroupStyle>
                <BtnStyle>
                    <Button color="primary" 
                        isNegative={true}
                        id="startQuoteBtn"
                        onClick={() => {
                            _gaPushEvent('getquote');
                            props.history.push((props.site ? '/' + props.site : '') + '/quote/size');
                    }}>Start&nbsp;Quote</Button>
                </BtnStyle>
            <BannerSelectionWarningBubbleStyle>Policy can be incepted up to 90 days in advance.</BannerSelectionWarningBubbleStyle>
        </BannerStyle>
    );
}

export default withRouter(LandingBanner);
